import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SortCodeInput as CleanSortCodeInput } from '../../components';

const SortCodeInput: React.FC<any> = ({ name, state, ...props }) => {
  const { control } = useFormContext<any>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CleanSortCodeInput
          {...field}
          onChange={(e) => {
            const output = e.target.value.split('-').join('');
            field.onChange(output ? output : null);
          }}
          state={state}
          {...props}
        />
      )}
    />
  );
};

export default SortCodeInput;
